import React, {useContext} from 'react';
import OutputLine from "./OutputLine";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import ICON_TYPES from "../../../../../../src/js/misc/IconTypes";
import iconTypeField from "../iconTypes/iconTypeField";
import escapeOutputString from "../../../misc/escapeOutputString";
import PropTypes from "prop-types";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
};
const defaultProps = {};

const HeaderLogoOutput = ({baseIndent}) => {
	const {configuratorStore} = useContext(MobXContext);

	let logoTextField = configuratorStore.headerLogoType && iconTypeField(configuratorStore.headerLogoType, 'headerLogo');
	let logoFieldOutput;
	switch (configuratorStore.headerLogoType) {
		case ICON_TYPES.DOMNODE:
			logoFieldOutput = `window.utahHeader.renderDOM('${escapeOutputString(configuratorStore.headerLogoDom)}')`;
			break;

		case ICON_TYPES.FUNCTION:
			logoFieldOutput = configuratorStore.headerLogoFunction;
			break;

		case ICON_TYPES.STRING:
			logoFieldOutput = `'${escapeOutputString(configuratorStore.headerLogoString)}'`;
			break;

		case ICON_TYPES.URL:
			logoFieldOutput = `'${encodeURI(escapeOutputString(configuratorStore.headerLogoUrl))}'`;
			break;

		default:
			configuratorStore.headerLogoType && console.error(`HeaderLogoOutput: Unknown header logo type: ${configuratorStore.headerLogoType}`);
			break;
	}

	return (
		configuratorStore.headerLogoType ?
			<>
				{
					configuratorStore.headerLogoAltText ?
						<OutputLine indent={baseIndent} highlightableField="headerLogoAltText">
							{`headerLogoAltText: "${configuratorStore.headerLogoAltText}",`}
						</OutputLine> :
						undefined
				}

				<OutputLine indent={baseIndent} highlightableField={logoTextField}>
					{`headerLogo: ${logoFieldOutput},`}
				</OutputLine>

				<OutputLine indent={baseIndent} highlightableField="headerLogoType">
					{`headerLogoType: '${configuratorStore.headerLogoType}',`}
				</OutputLine>
			</>
			: null
	);
};

HeaderLogoOutput.propTypes = propTypes;
HeaderLogoOutput.defaultProps = defaultProps;

export default observer(HeaderLogoOutput);
